<template>
  <h2>Editorial Team</h2>
</template>

<script>
export default {};
</script>

<style>
</style>